module.exports = __webpack_public_path__ + "static/media/Michael-Dolan.7de66151.jpg";